import {
	getOrganizationQueryOptions,
	useGetOrganization,
} from "@package/api-client/hooks/organizationController";
import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { OrgBaseLayout } from "../../../../../components/layout/org-base-layout.tsx";

export const Route = createFileRoute("/_auth/app/_app/org/$orgId")({
	loader: async ({ context, params }) => {
		context.queryClient.ensureQueryData(getOrganizationQueryOptions(params.orgId));
		return { orgId: params.orgId };
	},
	component: OrganizationLayout,
	errorComponent: OrganizationErrorPage,
});

function OrganizationLayout() {
	const { orgId } = Route.useParams();
	const navigate = useNavigate();
	const { data: organization } = useGetOrganization(orgId);

	useEffect(() => {
		if (!orgId) {
			navigate({ to: "/app/select-organization" });
			return;
		}
		localStorage.setItem("comms:lastOrgId", orgId);
	}, [orgId, navigate]);

	const organizationName = organization?.name ?? orgId;

	return (
		<OrgBaseLayout organizationName={organizationName}>
			<Outlet />
		</OrgBaseLayout>
	);
}

function OrganizationErrorPage() {
	const navigate = useNavigate();

	useEffect(() => {
		navigate({ to: "/app/select-organization" });
	}, [navigate]);

	return (
		<div className="min-h-screen flex items-center justify-center">
			<div className="loading loading-spinner loading-lg" />
		</div>
	);
}
